module.exports = __webpack_public_path__ + "img/T7A6691.25ad55eb.jpg";